import { InfoBlock as AntdInfoBlock, InfoBlockSkeleton as AntdInfoBlockSkeleton } from "@empglabs/backoffice-ui-kit"

const InfoBlock = props => {
  return <AntdInfoBlock {...props} />
}

export const InfoBlockSkeleton = props => {
  return <AntdInfoBlockSkeleton {...props} />
}
export default InfoBlock
